import template from './swag-cms-extensions-block-config-quickview.html.twig';
import './swag-cms-extensions-block-config-quickview.scss';

export default {
    template,

    inject: [
        'repositoryFactory',
        'acl',
    ],

    props: {
        block: {
            type: Object,
            required: true,
        },
    },

    computed: {
        productRelatedBlocks() {
            return [
                'product-listing',
                'product-slider',
                'product-three-column',
                'cross-selling',
            ];
        },

        productRelatedSlots() {
            return [
                'product-box',
                'product-slider',
            ];
        },

        blockIsProductRelated() {
            const productRelatedSlot = this.block.slots.some((slot) => this.productRelatedSlots.includes(slot.type));

            return (productRelatedSlot || this.productRelatedBlocks.includes(this.block.type));
        },

        quickviewRepository() {
            return this.repositoryFactory.create('swag_cms_extensions_quickview');
        },

        quickviewExtensionDefined() {
            return this.block.extensions.swagCmsExtensionsQuickview !== undefined;
        },

        quickview() {
            if (this.quickviewExtensionDefined) {
                return this.block.extensions.swagCmsExtensionsQuickview;
            }
            // Prevents a superfluous call to create(), if the block cannot make use of the quickview
            return this.blockIsProductRelated ? this.quickviewRepository.create(Shopware.Context.api) : {};
        },
    },

    methods: {
        quickviewActiveChanged(state) {
            if (this.quickviewExtensionDefined) {
                return;
            }

            this.quickview.active = state;
            this.block.extensions.swagCmsExtensionsQuickview = this.quickview;
        },
    },
}
